import { RestaurantFormData } from "../../views/RestaurantManagment/AddRestaurant";
import { apiSlice } from "../apiSlice";

export interface restaurantBankDataUpdateRequest {
  restaurantId: string;
  accountName: string;
  accountNumber: string;
  bankName: string;
  branchName: string;
  swiftCode: string;
}

const API_BASE_DOMAIN = process.env.REACT_APP_API_BASE_DOMAIN_PRODUCTION;
export const restaurantService = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createRestaurantHttps: builder.mutation<string, RestaurantFormData>({
      query: (data) => ({
        url: `https://adminhttps-createrestaurant-${API_BASE_DOMAIN}-uc.a.run.app/`,
        method: "POST",
        body: data,
        responseHandler: (response) => response.json(),
      }),
    }),
    updateRestaurantHttps: builder.mutation<
      string,
      { restaurantId: string; data: any }>({
        query: ({ restaurantId, data }) => ({
          url: `https://adminhttps-updaterestaurant-${API_BASE_DOMAIN}-uc.a.run.app?restaurantId=${restaurantId}`,
          method: "PUT",
          body: data,
        }),
      }),
    getRestaurantTypes: builder.query({
      query: () =>
        `https://adminhttps-getrestauranttypeslist-${API_BASE_DOMAIN}-uc.a.run.app`,
    }),
    getRestaurantCategories: builder.query({
      query: () =>
        `https://adminhttps-getcategorylistforrestaurant-${API_BASE_DOMAIN}-uc.a.run.app`,
    }),
    getRestaurantProperties: builder.query({
      query: () =>
        `https://adminhttps-getrestaurantpropertylist-${API_BASE_DOMAIN}-uc.a.run.app/`,
    }),
    updaterestaurantBankData: builder.mutation<any, restaurantBankDataUpdateRequest>({
      query: (data) => ({
        url: `https://adminhttps-addrestaurantbankdetails-${API_BASE_DOMAIN}-uc.a.run.app/`,
        method: "POST",
        body: data,
        responseHandler: (response) => response.text(),
      }),
    }),
    getrestaurantBankData: builder.query({
      query: (restaurantId) =>
        `https://superadminhttps-getrestaurantwalletdata-${API_BASE_DOMAIN}-uc.a.run.app?restaurantId=${restaurantId}`,
    }),
    getRestaurantFlowTypes: builder.query({
      query: () =>
        `https://adminhttps-getflowtypeslist-${API_BASE_DOMAIN}-uc.a.run.app`,
    }),
  }),
});

export const {
  useCreateRestaurantHttpsMutation,
  useUpdateRestaurantHttpsMutation,
  useGetRestaurantTypesQuery,
  useGetRestaurantCategoriesQuery,
  useLazyGetRestaurantCategoriesQuery,
  useGetRestaurantPropertiesQuery,
  useLazyGetRestaurantPropertiesQuery,
  useUpdaterestaurantBankDataMutation,
  useGetrestaurantBankDataQuery,
  useLazyGetrestaurantBankDataQuery,
  useGetRestaurantFlowTypesQuery,
} = restaurantService;
